// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__VRAL0","content":"layout_content__uicDo"};